export enum PaymentStatus {
	created = 'created',
	done = 'done',
	reserved = 'reserved',
	cancelled = 'cancelled',
	failed = 'failed',
}
